// extracted by mini-css-extract-plugin
export default {"container":"UploadAttachment_container__4WZOS"};